export const ProfileCountriesVisitedEditPath = 'profile-countries-visited-edit'
